import React from 'react'
import { motion } from 'framer-motion'
import { Info, ExternalLink } from 'lucide-react'

import { supportConfig } from '../config/support'

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()

  return (
    <>
      {/* Footer */}
      <motion.footer
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 1 }}
        className="fixed bottom-0 left-0 right-0 bg-slate-900/90 backdrop-blur-sm border-t border-slate-700/50 z-40"
      >
        <div className="max-w-7xl mx-auto px-3 py-2">
          <div className="flex flex-col md:flex-row items-center justify-between gap-2">
            {/* Left side - App info */}
            <div className="flex items-center gap-2 text-xs text-gray-400">
              <span>Bible Reader</span>
              <span className="hidden md:inline">•</span>
              <span className="hidden md:inline">ESV Bible</span>
            </div>

            {/* Center - Navigation links */}
            <div className="flex items-center gap-2">
              <motion.a
                href="/about"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="flex items-center gap-1.5 bg-slate-700/50 hover:bg-slate-600/50 text-gray-300 px-2 py-1.5 rounded-md transition-all duration-300 text-xs font-medium"
              >
                <Info size={12} />
                <span>About</span>
              </motion.a>

              <motion.a
                href="/contact"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="flex items-center gap-1.5 bg-slate-700/50 hover:bg-slate-600/50 text-gray-300 px-2 py-1.5 rounded-md transition-all duration-300 text-xs font-medium"
              >
                <span>Contact</span>
              </motion.a>

              {supportConfig?.koFi?.url && (
                <motion.a
                  href={supportConfig.koFi.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="flex items-center gap-1.5 bg-bible-gold/20 hover:bg-bible-gold/30 text-bible-gold px-2 py-1.5 rounded-md transition-all duration-300 text-xs font-medium"
                >
                  <span>{supportConfig.koFi.icon}</span>
                  <span>Ko-fi</span>
                  <ExternalLink size={10} />
                </motion.a>
              )}
            </div>

            {/* Right side - Copyright */}
            <div className="flex items-center gap-1.5 text-xs text-gray-500">
              <span>© {currentYear} Bible Reader</span>
            </div>
          </div>
        </div>
      </motion.footer>
    </>
  )
}

export default Footer
